<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
  >
    <el-table-column
      v-for="(col, index) in columns"
      :key="index"
      :prop="col.prop"
      :label="col.label"
      align="center"
    >
      <template #default="scope">
        <div v-html="scope.row[col.prop]"></div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { ref } from 'vue';

const tableData = ref([
  {
    prop: 'barcodeType',
    label: '条码类别',
    content: '一维码:Code39, Code93, Code128, CodaBar，EAN8, EAN13, UPCA, UPCE, ITF14, ITF25，Matrix25，MSI，ChinaPost，Code 11等<br>二维码:QR，DM 等<br>堆叠码:PDF417等'
  },
  {
    prop: 'maxFrameRate',
    label: '最大处理帧率',
    content: '30 fps'
  },
  {
    prop: 'maxReadSpeed',
    label: '最大读取速度',
    content: '90 个码/秒'
  },
  {
    prop: 'sensorType',
    label: '传感器类型',
    content: 'CMOS，卷帘快门'
  },
  {
    prop: 'pixelSize',
    label: '像元尺寸',
    content: '2.4 μm * 2.4 μm'
  },
  {
    prop: 'targetSize',
    label: '靶面尺寸',
    content: '1/1.8"'
  },
  {
    prop: 'resolution',
    label: '分辨率',
    content: '3072*2048'
  },
  {
    prop: 'exposureTime',
    label: '曝光时间',
    content: '16 μs -1 sec'
  },
  {
    prop: 'gain',
    label: '增益',
    content: '0 dB -40 dB'
  },
  {
    prop: 'bWColor',
    label: '黑白/彩色',
    content: '黑白'
  },
  {
    prop: 'communicationProtocol',
    label: '通讯协议',
    content: 'SmartSDK, TCP Client, Serial, FTP, TCP Server, PROFINET,Ethernet/IP, MELSEC, Fins, ModBus， SLMP'
  },
  {
    prop: 'dataInterface',
    label: '数据接口',
    content: 'Gigabit Ethernet(1000 Mbit/s)'
  },
  {
    prop: 'digitalIO',
    label: '数字I/O',
    content: '12-pinM12接头提供电源和I/O:包含3路光耦隔离输入(LineIn 0/1/2)，3路光耦隔离输(LineOut 3/4/5)，1路RS-232输入，1路RS-232 输出'
  },
  {
    prop: 'powerSupply',
    label: '供电',
    content: '24 VDC'
  },
  {
    prop: 'maxPower',
    label: '最大功率',
    content: '20 W@24 VDC(启用自带补光灯)'
  }
]);

const columns = ref([
  {
    label: '项目',
    prop: 'label'
  },
  {
    label: '内容',
    prop: 'content'
  }
]);
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>